/**
 * Der Knopf „Zollinstruktionen anstoßen“ samt Dialog als nachgeladener Chunk: `ZollKnopf.tsx` importiert den `ZollDialog` statisch, beide
 * (samt `zollinstruktionen.css` und `api/zollinstruktionen.ts`) liegen in `assets/ZollKnopf-*.js` und nicht im Eintrittsbuendel (Grenze in
 * `test/reference/bundle.test.ts`, Kategorie N). Hier, im Eintritt, steht nur diese Huelle: der Abruf, die Grenze und der Platzhalter.
 * Verwendet vom Reiter Spedition (`Drawer/ShipTab/SpeditionTab.tsx`) und vom Sammelsendungs-Drawer (`Drawer/SammelsendungDrawer.tsx`).
 *
 * Der Chunk laedt, sobald einer der beiden den Knopf zeichnet; der Dialog selbst braucht danach keinen weiteren Abruf. Bis dahin steht
 * ein Platzhalter gleicher Hoehe (`zoll-anstossen-platzhalter`, `styles/neubau/zollKnopf.css`): der Reiter springt nicht, wenn der Knopf
 * erscheint. Er ist fuer Hilfstechnik verborgen und enthaelt keinen Text.
 *
 * Die Grenze `NachladeGrenze` (`components/NachladeGrenze.tsx`, auch vom Chunk fuer den Dialog benutzt) faengt den Ladefehler: scheitert
 * der Abruf (ein alter Tab nach einem Deployment kennt den Chunk nicht mehr), meldet sie ueber den Melder und zeichnet nichts - Board
 * und Drawer bleiben stehen, siehe dort.
 *
 * Importiert `state/fehlerStapel.ts` NICHT (Rolldown-Falle, siehe `ZollDialog.tsx`); Meldungen gehen ueber den `melder`. Die Props kommen
 * nur als TYP aus `ZollKnopf.tsx` - ein Wert-Import zoege den Chunk ins Eintrittsbuendel.
 */
import { lazy, Suspense } from "react";
import { ZOLL_ANZEIGE_FEHLER } from "../../lib/zollinstruktionen.ts";
import { Ikone } from "../Ikone.tsx";
import { NachladeGrenze } from "../NachladeGrenze.tsx";
import type { ZollKnopfProps } from "./ZollKnopf.tsx";

const ZollKnopfChunk = lazy(() => import("./ZollKnopf.tsx").then((m) => ({ default: m.ZollKnopf })));

/**
 * Dieselben Masse wie der Knopf (`btn-primary` samt Ikone und einer Textzeile), unsichtbar: die CSS setzt `visibility: hidden`.
 * Ohne Ikone und Zeile waere er niedriger als der Knopf, und der Reiter spraenge beim Erscheinen.
 */
function Platzhalter() {
  return (
    <div className="zoll-anstossen" aria-hidden="true">
      <span className="btn-primary zoll-anstossen-platzhalter">
        <Ikone name="send" />
        {" "}
      </span>
    </div>
  );
}

export function ZollKnopfLazy(props: ZollKnopfProps) {
  return (
    <NachladeGrenze melde={props.melder.fehler} kontext={ZOLL_ANZEIGE_FEHLER}>
      <Suspense fallback={<Platzhalter />}>
        <ZollKnopfChunk {...props} />
      </Suspense>
    </NachladeGrenze>
  );
}
